module.exports = __webpack_public_path__ + "img/Holt_Danny2020-06-24.8f700f12.png";